export default "__VITE_ASSET__DlKVbi7w__"